import { TimelineUpdate } from '@groundfloor-platform/types-event-grid-events';
import { SignalREventCentre } from '../signalR.eventCentre';
import { ISignalRService } from '../signalR.types';
import { TimelineUpdatesSubscriptionStream, TimelineUpdatesSignalRAttributeName } from './timelineUpdates.types';

export class TimelineUpdatesEventCentre extends SignalREventCentre<TimelineUpdate, TimelineUpdatesSubscriptionStream> {
  private static instance: TimelineUpdatesEventCentre;

  private constructor(signalR: ISignalRService) {
    super(signalR, TimelineUpdatesSignalRAttributeName, ['deliveryIDs', 'workflowIDs', 'projectIDs']);
  }

  public static getInstance(signalR: ISignalRService) {
    if (!this.instance) {
      this.instance = new TimelineUpdatesEventCentre(signalR);
    }
    return this.instance;
  }
}
